/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import ResultList from "./ResultList";
import Pagination from "./Pagination";
import config from "../../app/config";
import { RCL } from "../../components/RCL";

let styles;

(async () => {
  if (config.isWestJetMode) {
    styles = await import("./FaqSearchResultVwq.module.scss");
  } else {
    styles = await import("./FaqSearchResult.module.scss");
  }
})();

const FaqSearchResult = ({searchText, searchResult, helpfulInfoSections, setSelectedInfo, setSelectedSection, setShowSearchResult}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const infosPerPage = 10;
  const indexOfLastResult = currentPage * infosPerPage;
  const indexOfFirstResult = indexOfLastResult - infosPerPage;
  const currentResults = searchResult?.length > 0 ? searchResult?.slice(indexOfFirstResult, indexOfLastResult):[];

  return (
    <>
    {styles && (
      <div>
        <span className={styles.resultHeader}> {`${searchResult?.length} ${RCL({ searchKey: "search-results-for" })} "${searchText}"`}</span>
        <div className={styles.container}>
          {currentResults && currentResults?.length > 0 && 
            (
              <>
                <ResultList 
                  currentResults={currentResults} 
                  searchText={searchText} 
                  helpfulInfoSections={helpfulInfoSections} 
                  setSelectedInfo={setSelectedInfo} 
                  setSelectedSection={setSelectedSection} 
                  setShowSearchResult={setShowSearchResult}/>
                <Pagination
                  infosPerPage={infosPerPage}
                  totalInfos={searchResult?.length}
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage} />
              </>
            )
          }
        </div>
      </div>
        )
      }
      </>
  );
};

export default FaqSearchResult;